import * as types from './reportActionTypes';

export default (state = true, action) => {
    switch (action.type) {
        case types.LOAD_REPORTS:
            return true;
        case types.LOAD_REPORTS_FAILED:
        case types.LOAD_REPORTS_SUCCESS:
            return false;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reports/reportsIsLoadingReducer.js